import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IClassifier, IClassifierEditModel } from '../../models/Classifier';
import { ClassifierService } from '../../services/classifier.service';
import { Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { delay, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-classifier-edit',
    templateUrl: './classifier-edit.component.html'
})
export class ClassifierEditComponent {
    constructor(
        private app: AppService,
        private service: ClassifierService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set item(value: IClassifier) {
        this.id = value.Id;

        this.model.Code = value.Code;
        this.model.LegacyCode = value.LegacyCode;
        this.model.Payload = value.Payload;
        this.model.Type = value.Type;
        this.model.ValueLV = value.ValueLV;
        this.model.ValueEN = value.ValueEN
    }

    readonly model: IClassifierEditModel = <IClassifierEditModel>{};

    id: string;
    isSaving: boolean;

    @ViewChild('form', { static: true }) private form: NgForm;

    save() {
        if (this.form.invalid) {
            return;
        }

        const success = () => {
            this.activeModal.close();
        };

        this.isSaving = true;

        const req = this.id
            ? this.service.update(this.id, this.model)
            : this.service.create(this.model);

        req.pipe(delay(500), finalize(() => this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
